import {useQuery} from '@tanstack/react-query'
import {getList} from '../../../app/getters/getList.js'

export const useListaUzytkownikowSystemu = (enabled = true) => {
    return useQuery({
        queryKey: ['oper_uzytkownicy_systemu'],
        queryFn: () => getList('oper/uzytkownicy'),
        enabled,
    })
}
